module.exports = __webpack_public_path__ + "static/images/chevron-down-small.7c3e8a51a0119d3c8b1e84f47065c66d.svg";